import {
  breakpoints,
  IBasicStyledProps,
  IconSolidInfo,
  theme,
} from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  line-height: 1.3125rem;
  font-size: 0.875rem;
  margin: 0.75rem 0 1rem;
`;

export const CodeBlock = styled.span`
  color: ${theme.color.text.secondary};
`;

export const CodeName = styled.span`
  display: none;

  @media (min-width: ${breakpoints.sm}) {
    display: inline;
  }
`;

export const Separator = styled.span`
  color: ${theme.color.text.disabled};
`;

export interface IAvailabilityProps extends IBasicStyledProps {
  highlight: boolean;
}

export const Availability = styled.span<IAvailabilityProps>`
  color: ${(props: IAvailabilityProps) =>
    props.highlight ? theme.color.text.negative : theme.color.text.positive};

  font-weight: ${({ highlight }) => (highlight ? 500 : 'normal')};
`;

export const StyledInfoIcon = styled(IconSolidInfo)`
  margin-bottom: 3px;
`;

export const TooltipContent = styled.div`
  max-width: max-content;
  width: 18rem;
  padding: 0.5rem;
`;
